import React from "react";
import HorizontalRule from "../../../../components/components/atoms/HorizontalRule";
import { Heading } from "@telia/teddy";

interface Props {
    text: string;
}

const Header = ({ text }: Props) => {
    return (
        <>
            <Heading as="h1" variant="title-300" mb="200">
                {text}
            </Heading>
            <HorizontalRule />
        </>
    );
};

export default Header;
